import { IEventCoordinatorDTO } from '../../api/events.dao';

export const stringifyStaffMembers = (list: IEventCoordinatorDTO[] = [], count = 25): string[] => (
    list
        .slice(0, count)
        .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
);
